import {Directive, OnDestroy} from "@angular/core";

import {TIPEmailBuilderStyles} from "../../interfaces";
import {AIPEmailBuilderBlock} from "../../core/Block";

/**
 * Builder {@link SnippetBlock} options interface.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ISnippetBlockOptions {
}

@Directive()
export class SnippetBlock extends AIPEmailBuilderBlock<ISnippetBlockOptions> implements OnDestroy {
  override type = "snippet";
  innerText = "Snippet";
  options: ISnippetBlockOptions = {}

  get hostStyles(): TIPEmailBuilderStyles {
    return {};
  }

  override toObject(options?: Partial<ISnippetBlockOptions>, innerText = this.innerText) {
    return {...super.toObject(options), innerText};
  }
}
